import { parseError, useSubmitProps } from "core/shared";
import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";
import { useCallback, useState } from "react";

export function useStartCancelingOrder({ onSuccess, onError }: useSubmitProps) {
  const [cancelingReasons, setCancelingReasons] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const getCancelingReasons = action(URLS.account.cancelingReasons);

  const startCanceling = useCallback(() => {
    setIsLoading(true);
    getCancelingReasons()
      .then((response) => {
        setCancelingReasons(response.data.reasons);
        setIsLoading(false);

        onSuccess?.(response.data);
      })
      .catch((error) => {
        onError?.(error.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return { startCanceling, cancelingReasons, isLoading };
}

export function useCancelOrder(
  orderId: number,
  { onSuccess, onError }: useSubmitProps,
) {
  const [_, setSelectedCancelingReason] = useState<number | null>(null);
  const submit = action(URLS.account.cancelOrder);

  const submitCancelingOrder = async ({ form, values }) => {
    const {reason, notes} = values;

    const response = await submit({ orderId, reason: Number(reason), notes });

    form.submitting(false);

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { submitCancelingOrder, setSelectedCancelingReason };
}
